import React from "react";
import { Link } from "react-router-dom";

export default function MemberTerms() {
  return (
    <div className="member-policy-page">
      <header className="header member-policy-header">
        <div className="container">
          <Link to="/" className="header-logo">
            WHISPER
          </Link>
          <h2>이용약관</h2>
          <Link to="/" className="btn btn-outline-primary btn-sm">
            홈으로 이동
          </Link>
        </div>
      </header>
      <main className="member-policy-body p-4 p-lg-5">
        <div className="member-policy-content">
          <h2 style={{ textAlign: "center", marginBottom: "2rem" }}>이용약관</h2>
          <h2>목차</h2>
          <ol>
            <li><a href="#a1">제1조 목적</a></li>
            <li><a href="#a2">제2조 용어의 정의</a></li>
            <li><a href="#a3">제3조 약관의 효력 및 변경</a></li>
            <li><a href="#a4">제4조 이용계약의 체결</a></li>
            <li><a href="#a5">제5조 서비스의 내용 및 제공</a></li>
            <li><a href="#a6">제6조 서비스 이용의 제한</a></li>
            <li><a href="#a9">제9조 이용요금 및 결제</a></li>
            <li><a href="#a10">제10조 환불</a></li>
            <li><a href="#a11">제11조 회원의 의무</a></li>
            <li><a href="#a12">제12조 저작권</a></li>
            <li><a href="#a13">제13조 투자 판단 및 책임(고지)</a></li>
            <li><a href="#a14">제14조 데이터 지연·오류 및 외부 제공처 면책</a></li>
            <li><a href="#a15">제15조 면책</a></li>
            <li><a href="#a16">제16조 준거법 및 관할</a></li>
            <li><a href="#b1">부칙</a></li>
          </ol>
          <div>
            <strong>중요 고지:</strong> 본 서비스는 투자자문·투자권유가 아니며, 투자 결과에 대한 책임은 이용자에게 있습니다.
          </div>
          <br />
          <h2>약관 본문</h2>
          <div id="a1">
            <p >제1조 (목적)</p>
            <p>본 약관은 구루위스퍼(이하 “회사”)가 제공하는 주식·금융 정보 및 이에 부수하는 온라인 서비스(이하 “서비스”)의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>
          </div>

          <div id="a2">
            <p>제2조 (용어의 정의)</p>
            <ol>
              <li>“서비스”란 회사가 제공하는 주식 정보, 데이터 분석, 콘텐츠, 기타 관련 기능 일체를 의미합니다.</li>
              <li>“이용자”란 본 약관에 따라 서비스를 이용하는 자를 말합니다.</li>
              <li>“회원”이란 회사와 이용계약을 체결하고 서비스를 이용하는 자를 말합니다.</li>
              <li>“유료서비스”란 회사가 별도의 대가를 받고 제공하는 서비스를 말합니다.</li>
            </ol>
          </div>

          <div id="a3">
            <p>제3조 (약관의 효력 및 변경)</p>
            <ol>
              <li>본 약관은 서비스 화면에 게시하거나 기타 방법으로 공지함으로써 효력이 발생합니다.</li>
              <li>회사는 관련 법령을 위반하지 않는 범위에서 약관을 변경할 수 있습니다.</li>
              <li>변경된 약관은 적용일자 및 변경 사유를 명시하여 사전에 공지합니다.</li>
              <li>회원이 변경된 약관에 동의하지 않는 경우 서비스 이용을 중단하고 이용계약을 해지할 수 있습니다.</li>
            </ol>
          </div>

          <div id="a4">
            <p>제4조 (이용계약의 체결)</p>
            <ol>
              <li>이용계약은 이용자가 약관에 동의하고 회원가입을 신청한 후 회사가 이를 승인함으로써 체결됩니다.</li>
              <li>회사는 다음 각 호에 해당하는 경우 가입을 제한하거나 사후에 이용계약을 해지할 수 있습니다.
                <ul>
                  <li>허위 정보를 기재한 경우</li>
                  <li>관련 법령 또는 본 약관을 위반한 경우</li>
                </ul>
              </li>
            </ol>
          </div>

          <div id="a5">
            <p>제5조 (서비스의 내용 및 제공)</p>
            <ol>
              <li>회사는 다음과 같은 서비스를 제공합니다.
                <ul>
                  <li>주식 및 금융 관련 정보 제공</li>
                  <li>데이터 분석 및 참고 자료 제공</li>
                  <li>기타 회사가 정하는 정보 서비스</li>
                </ul>
              </li>
              <li>서비스의 구체적인 내용은 회사의 정책에 따라 변경될 수 있습니다.</li>
              <li>회사는 서비스의 전부 또는 일부를 중단하거나 변경할 수 있으며, 필요한 경우 사전 공지합니다.</li>
            </ol>
          </div>

          <div id="a6">
            <p>제6조 (서비스 이용의 제한)</p>
            <p>회사는 다음 각 호의 경우 회원의 서비스 이용을 제한하거나 중단할 수 있습니다.</p>
            <ol>
              <li>시스템 점검, 장애 또는 불가피한 사유가 있는 경우</li>
              <li>회원이 법령 또는 본 약관을 위반한 경우</li>
              <li>서비스의 정상적인 운영을 방해한 경우</li>
            </ol>
          </div>

          <div id="a9">
            <p>제9조 (이용요금 및 결제)</p>
            <ol>
              <li>회원은 회사가 제공하는 서비스 중 유료서비스의 이용요금은 회사가 정하여 서비스 화면에 공지합니다.</li>
              <li>이용요금의 결제는 신용카드, 실시간 계좌이체, 전자지급결제대행 등 회사가 정하는 방법에 따릅니다.</li>
              <li>회원은 정기결제 자동갱신 서비스 제공에 동의한 경우, 별도 해지 요청이 없으면 이용요금이 자동으로 결제됩니다.</li>
              <li>회사는 결제 오류, 중복결제 등 오류 발생 시 관련 법령에 따라 조치합니다.</li>
            </ol>
          </div>

          <div id="a10">
            <p>제10조 (환불)</p>
            
            <p>회사는 다음과 같은 환불 정책을 적용합니다.</p>
          
            <ol>
              <li><strong>기간제 유료서비스(1개월 이상)</strong>
                <ul>
                  <li>결제 후 <strong>7일 이내</strong> 해지 요청 시, 사용한 기간을 제외한 잔여 기간에 대해 환불합니다.</li>
                  <li>결제 후 <strong>7일 초과</strong> 후에는 잔여 기간에 대해 환불하되, 회사가 정하는 환불수수료를 공제합니다.</li>
                </ul>
              </li>
              <li><strong>정기월간 결제</strong>
                <ul>
                  <li>결제 후 <strong>7일 이내</strong> 해지 요청 시, 사용한 기간을 제외한 잔여 기간에 대해 환불합니다.</li>
                  <li><strong>7일 초과</strong> 시 환불은 제한되거나 환불수수료가 부과될 수 있습니다.</li>
                </ul>
              </li>
              <li><strong>정기연간 결제</strong>
                <ul>
                  <li>결제 후 <strong>3일 이내</strong> 해지 요청 시 전액 환불합니다.</li>
                  <li>결제일로부터 <strong>90일 이내</strong> 해지 시, 사용한 기간을 제외한 잔여 기간에 대해 환불합니다.</li>
                  <li>결제일로부터 <strong>90일 초과</strong> 시 환불이 제한됩니다.</li>
                </ul>
              </li>
              <li>환불 금액은 결제 수단 취소, 환불수수료 공제 등을 포함하여 처리됩니다.</li>
              <li>유료서비스 이용 중 부당한 방법으로 혜택이 적용된 경우, 회사는 환불을 제한할 수 있습니다.</li>
            </ol>
          </div>

          <div id="a11">
            <p>제11조 (회원의 의무)</p>
            <p>회원은 다음 각 호의 행위를 하여서는 안 됩니다.</p>
            <ol>
              <li>허위 또는 타인의 정보로 회원가입을 하는 행위</li>
              <li>서비스 내 정보를 무단 복제, 배포, 변형하는 행위</li>
              <li>회사 또는 제3자의 권리를 침해하는 행위</li>
              <li>관련 법령 또는 본 약관을 위반하는 행위</li>
            </ol>
          </div>

          <div id="a12">
            <p>제12조 (저작권)</p>
            <ol>
              <li>서비스에 포함된 모든 콘텐츠에 대한 저작권은 회사 또는 정당한 권리자에게 귀속됩니다.</li>
              <li>회원은 회사의 사전 동의 없이 콘텐츠를 이용하여 영리 행위를 할 수 없습니다.</li>
            </ol>
          </div>

          <div id="a13">
            <p>제13조 (투자 판단 및 책임(고지))</p>
            <ol>
              <li>회사가 제공하는 모든 정보는 투자 판단을 위한 참고 자료이며, 투자 자문 또는 투자 권유에 해당하지 않습니다.</li>
              <li>회사는 특정 금융상품의 매수·매도, 투자 실행을 권유하거나, 투자자문 서비스를 제공하지 않습니다.</li>
              <li>투자에 대한 최종 판단과 그 결과(손실 포함)에 대한 책임은 전적으로 회원 본인에게 있습니다.</li>
              <li>회사는 서비스 이용으로 발생한 투자 손실에 대해 어떠한 책임도 부담하지 않습니다.</li>
            </ol>
          </div>

          <div id="a14">
            <p>제14조 (데이터 지연·오류 및 외부 제공처 면책)</p>
            <ol>
              <li>서비스에 제공되는 데이터 및 정보는 지연, 오류 또는 중단이 발생할 수 있으며, 회사는 이에 대한 책임을 지지 않습니다.</li>
              <li>회사가 외부 기관 또는 제3자 정보 제공처로부터 데이터를 수신·연동하는 경우, 해당 제공처의 오류·지연·중단에 대해 회사는 책임을 지지 않습니다.</li>
              <li>회원이 서비스 정보를 오용하거나 오해하여 발생한 결과에 대해 회사는 책임을 지지 않습니다.</li>
            </ol>
          </div>

          <div id="a15">
            <p>제15조 (면책)</p>
            <ol>
              <li>회사는 천재지변, 시스템 장애 등 불가항력적인 사유로 인한 서비스 중단에 대해 책임을 지지 않습니다.</li>
              <li>회사는 제공 정보의 정확성, 완전성 또는 특정 목적에 대한 적합성을 보장하지 않습니다.</li>
            </ol>
          </div>

          <div id="a16">
            <p>제16조 (준거법 및 관할)</p>
            <ol>
              <li>본 약관은 대한민국 법령에 따라 해석됩니다.</li>
              <li>서비스 이용과 관련하여 발생한 분쟁은 회사 본점 소재지를 관할하는 법원을 전속 관할로 합니다.</li>
            </ol>
          </div>

          <div id="b1">
            <p>부칙</p>
            <p>본 약관은 <strong>2026년 3월 17일부터</strong> 시행합니다.</p>
          </div>
        </div>
      </main>
    </div>
  );
}
